import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const ReminderEmailModal = ({ isOpen, onClose, certificate }) => {
  const [emailData, setEmailData] = useState({
    to: '',
    subject: '',
    body: '',
  });

  if (!isOpen || !certificate) return null;

  const generateEmailTemplate = () => {
    const subject = `Certificate Renewal Required - ${certificate?.propertyId}`;
    const body = `Dear Landlord,\n\nThis is a reminder that the ${certificate?.typeName} for your property at ${certificate?.address} (Property ID: ${certificate?.propertyId}) is due to expire on ${certificate?.expiryDate}.\n\nCurrent Status: ${certificate?.daysUntilExpiry < 0 ? 'EXPIRED' : `Expires in ${certificate?.daysUntilExpiry} days`}\n\nPlease arrange for renewal as soon as possible to maintain compliance with UK letting regulations.\n\nIf you have already arranged renewal, please upload the new certificate to our system.\n\nBest regards,\nLetOps Property Management`;

    setEmailData({
      to: 'landlord@example.com',
      subject,
      body,
    });
  };

  React.useEffect(() => {
    if (isOpen && certificate) {
      generateEmailTemplate();
    }
  }, [isOpen, certificate]);

  const handleSend = () => {
    console.log('Sending email:', emailData);
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content max-w-3xl" onClick={(e) => e?.stopPropagation()}>
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-2xl font-semibold text-foreground font-heading">Generate Renewal Reminder</h2>
          <button
            onClick={onClose}
            className="h-10 w-10 rounded-lg bg-input border border-border flex items-center justify-center transition-smooth hover:bg-muted"
            aria-label="Close"
          >
            <Icon name="X" size={20} color="var(--color-muted-foreground)" />
          </button>
        </div>

        <div className="space-y-4">
          <div className="p-4 rounded-lg bg-accent/10 border border-accent/20">
            <div className="flex items-start gap-3">
              <Icon name="Info" size={20} color="var(--color-accent)" className="mt-0.5" />
              <div>
                <p className="text-sm font-medium text-foreground mb-1">Certificate Details</p>
                <p className="text-xs text-muted-foreground">
                  {certificate?.typeName} • {certificate?.propertyId} • Expires {certificate?.expiryDate}
                </p>
              </div>
            </div>
          </div>

          <Input
            label="To"
            type="email"
            placeholder="Enter recipient email"
            value={emailData?.to}
            onChange={(e) => setEmailData({ ...emailData, to: e?.target?.value })}
            required
          />

          <Input
            label="Subject"
            type="text"
            placeholder="Enter email subject"
            value={emailData?.subject}
            onChange={(e) => setEmailData({ ...emailData, subject: e?.target?.value })}
            required
          />

          <div>
            <label className="text-sm font-medium text-foreground font-caption mb-2 block">Message</label>
            <textarea
              className="w-full h-64 px-4 py-3 rounded-lg bg-input border border-border text-foreground transition-smooth focus:outline-none focus:ring-2 focus:ring-ring resize-none"
              placeholder="Enter email message"
              value={emailData?.body}
              onChange={(e) => setEmailData({ ...emailData, body: e?.target?.value })}
              required
            />
          </div>

          <div className="flex gap-3 pt-6 border-t border-border">
            <Button variant="outline" fullWidth onClick={onClose}>
              Cancel
            </Button>
            <Button variant="default" fullWidth iconName="Send" iconPosition="left" onClick={handleSend}>
              Send Reminder
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReminderEmailModal;